export type ContactAgreementValues = (typeof contactAgreementValues)[number];

export const contactAgreementValues = ["enabled", "disabled"] as const;

export const dntCookieName = "_snrs_dnt";

export const dntCookieOptions = {
  expires: 365,
} as const;

export const srVendorName = "Synerise";
export const SYNERISE_HEALTH_TIMEOUT_MS = 5_000;
